import React from 'react';
import './Top.css';
import previewImage from './rust no recoil script preview.png';
import { FaShoppingCart, FaDiscord } from 'react-icons/fa';

const Top = () => {
  return (
    <div className="top-component">
      <div className="top-left">
        <h1>The safest Rust<br /> script on the <br /> market.</h1>
        <p>
          Tired of getting beamed? No worries we got your back!<br />
          <span style={{ color: "#CAF881" }}>
            The best hardware Rust script out there
          </span> that gives you an advantage
          over other players while beeing completely undetectable!
        </p>
        <div className="top-buttons">
          <button className="top-button buy-now"
            onClick={() => {
              window.location.href = "#pricing";
            }}
          >
            <FaShoppingCart />
            <span>Buy now</span>
          </button>
          <button
            className="top-button reviews"
            onClick={() => {
              window.open("https://eaglescript.space:5989/", "_blank");
            }}
          >
            <FaDiscord />
            <span>Join Discord</span>
          </button>
        </div>
      </div>
      <div className="top-right">
        <img src={previewImage} alt="Eagle Script Preview" />
      </div>
    </div>
  );
};

export default Top;
